import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { IsMobileWidth } from '@components/util/MediaQueryUtils';
import { ClickAwayListener, Divider, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import Button from '@components/Button/Button';
import CustomAutoComplete from '@components/auto.complete/auto.complete';
import CreateIcon from '@mui/icons-material/Create';
import TeamTable from '@components/team.table/team.table';
import {
  deleteInvite,
  deleteMembers,
  getUserTeamDetail,
  resendEmailInvite,
  sendEmailInvite,
  updateTeamName,
} from '@redux/services/teams';
import Modal from '@components/Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCustomAlert,
  setInvitedMembers,
  setLoading,
} from '@redux/actions/general';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@components/Input/Input';
import { useRouter } from 'next/router';
import LoadingState from '@components/Loader/LoadingState';
import LoadingScreen from '@components/Loader/LoadingScreen';
import { useTheme } from 'next-themes';
import SeatsCounter from '@components/seats.counter/seats.counter';
import CustomToolTip from '@components/custom.tooltip/custom.tooltip';
import apiConfig from '@config/api.service';
import { setTeam } from '@redux/actions/user';
import { restrictCreatingTeam } from '@helpers/utils';
import InviteModal from './invite.team';
import CreateTeamModal from './create.team';
import OutOfSeats from './OutOfSeats/OutOfSeats';
import AssignRole from './assign.role';
import UpdateSeat from './update.seat';

const useStyles = makeStyles({
  root: {
    minHeight: '85vh',
    paddingTop: '4px',
  },
  btnIcon: {
    // display: 'inline-block',
    height: '52px !important',
    width: '20px !important',
    color: 'white',
    // padding: 0,
    minHeight: 0,
    minWidth: 0,
    marginLeft: '10px',
  },
  doneBtn: {
    height: '52px !important',
    width: '48px !important',
    backgroundColor: '#2BAE68',
    minHeight: 0,
    minWidth: 0,
    color: 'white',
    '&:hover': {
      color: 'white',
      background: '#1E7A49',
    },
  },
  closeBtn: {
    height: '52px !important',
    width: '48px !important',
    backgroundColor: '#2499E7',
    minHeight: 0,
    minWidth: 0,
    color: 'white',
    '&:hover': {
      color: 'white',
      background: '#208AD0',
    },
  },
});
export default function ManageTeams({
  teamOptionValue,
  setTeamOptionValue,
  teamMembers,
  setTeamMembers,
  memberInfo,
  team,
  user,
  handleCreateNewTeam,
  localLoadingState,
  setLocalLoadingState,
  newTeamValue,
  setNewTeamValue,
  selectedTeam,
  setSelectedTeam,
  modalType,
  setModalType,
  inviteSent,
  setInviteSent,
  handleModalOpen,
  handleNewTeamModal,
  setMemberInfo,
  dataFetchedFrom,
}) {
  const mobileWidth = IsMobileWidth();
  const classes = useStyles();
  const [emailInviteValue, setEmailInviteValue] = useState('');
  const [editTeam, setEditTeam] = useState(false);
  const [editTeamName, setEditTeamName] = useState();
  const [addOnSeatsCount, setAddOnSeatsCount] = useState('0');
  const [addSeatLoading, setAddSeatLoading] = useState(false);
  const [updateSeatModal, setUpdateSeatModal] = useState(false);
  const [availableSeat, setAvailableSeat] = useState(null);
  const [totalSeats, setTotalSeats] = useState(null);
  const [helperState, setHelperState] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [ownersPlanData, setOwnersPlanData] = useState(null);
  const [freeAdditionalUser, setFreeAdditionaUser] = useState();
  const [showTooltip, setShowTooltip] = useState({
    plansSeats: false,
    updateSeats: false,
  });
  const [noOfSeats, setNoOfSeats] = useState({ type: null, seats: 0 });
  useEffect(() => {
    if (Number(addOnSeatsCount) === ownersPlanData?.users) {
      setShowTooltip({ plansSeats: true, updateSeats: false });
    }
  }, [addOnSeatsCount]);
  const {
    general: { modalOpen, isLoading: loading, invitedMembers },
  } = useSelector((state) => state);
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    if (+addOnSeatsCount > +totalSeats) {
      setNoOfSeats({ type: 'add', seats: +addOnSeatsCount - +totalSeats });
    } else if (+addOnSeatsCount < +totalSeats) {
      setNoOfSeats({
        type: 'subtract',
        seats: +totalSeats - +addOnSeatsCount,
      });
    } else {
      setNoOfSeats({
        type: null,
        seats: 0,
      });
    }
  }, [addOnSeatsCount, totalSeats]);
  useEffect(() => {
    setAddOnSeatsCount((availableSeat + teamMembers?.length).toString());
    setTotalSeats((availableSeat + teamMembers?.length).toString());
  }, [availableSeat, teamMembers]);
  useEffect(() => {
    setEditTeamName(selectedTeam?.label);
  }, [selectedTeam]);
  useEffect(() => {
    setAvailableSeat(
      ownersPlanData?.users +
        freeAdditionalUser +
        (ownersPlanData?.additionalSeats || 0) -
        teamMembers?.length
    );
  }, [ownersPlanData, teamMembers, user]);
  useEffect(() => {
    if (team.length) {
      const options = team.map((o) => ({
        label: o.title,
        id: o._id,
        owner:
          o.role === 'owner' ||
          o.role === 'administrator' ||
          o.accountType === 'personal-team',
        role: o?.role,
        planUsers: o?.userPlan?.quota?.users,
      }));
      setTeamOptionValue(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [team]);
  useEffect(() => {
    if (selectedTeam) {
      dispatch(setLoading(true));
      getUserTeamDetail(selectedTeam.id)
        .then((res) => {
          //   setUserPlan(res.data.data.userPlan);
          let {
            members,
            invitations,
            owner,
            cards,
            userPlan,
            freeAdditionalSeats,
          } = res.data.data;
          setFreeAdditionaUser(freeAdditionalSeats);
          setOwnersPlanData({
            additionalSeats: owner?.subscription?.additionalSeats,
            users: userPlan?.quota?.users,
          });
          if (cards) {
            setPaymentMethods(cards);
          }
          const teamMembersData = [];
          teamMembersData.push({ ...owner, role: 'owner' });
          members = members.map((o) => ({
            role: o.role,
            _id: o.user?._id,
            email: o.user.email || '',
            name: o.user.name,
            lastLogin: o.user.lastLogin,
            picture: o.user.picture,
            userId: o?._id || '',
            status: o?.status || '',
          }));
          invitations = invitations.map((o) => ({
            role: 'invited',
            _id: o._id,
            email: o.prospectedUser?.email || o.recipientEmail,
            name: o.prospectedUser?.name || '-',
            lastLogin: o.prospectedUser?.lastLogin || '-',
            picture: o.prospectedUser?.picture || null,
            status: 'pending',
          }));

          teamMembersData.push(...members, ...invitations);
          setTeamMembers(teamMembersData);
          dispatch(setLoading(false));

          //   if (user._id === owner._id) {
          //     setSelectedTeamRole('owner');
          //   } else {
          //     setSelectedTeamRole('member');
          //   }
          //   setLeftContainerLoading(false);
        })
        .catch((err) => {
          dispatch(
            setCustomAlert({
              message:
                err?.message ||
                'Something went wrong while fetching team member, Try again!',
              state: true,
              type: 'error',
            })
          );
          setTeamMembers([]);
          dispatch(setLoading(false));
        });
    }
    // eslint-disable-next-line
  }, [selectedTeam?.id, helperState]);
  console.log('teamOptions', teamOptionValue);
  const handleEditName = (title, id) => {
    setLocalLoadingState(true);
    updateTeamName(title, id).then((res) => {
      const { title: label, _id } = res?.data?.data;
      const teamOptions = teamOptionValue?.map((elem) => {
        if (elem?.id === _id) {
          return { ...elem, label };
        }
        return { ...elem };
      });

      // const teamOptionsRedux = teamOptionValue?.map((elem) => {
      //   if (elem?.id === _id) {
      //     return {
      //       ...elem,
      //       ...(res?.data?.data || {}),
      //       planUsers: elem?.planUsers,
      //     };
      //   }
      //   return elem;
      // });
      // console.log('teamOptions inner', teamOptionsRedux, teamOptionValue);
      setTeamOptionValue(teamOptions);
      // dispatch(setTeam(teamOptionsRedux));
      setEditTeam(false);
      setLocalLoadingState(false);
    });
  };

  useEffect(() => {
    console.log('selectedTeam', teamOptionValue);
    if (selectedTeam?.id) {
      const selectedOption = teamOptionValue?.find(
        ({ id }) => id === selectedTeam?.id
      );

      setSelectedTeam(selectedOption);
    } else {
      const teamOwner = teamOptionValue?.find(({ owner }) => owner);
      if (teamOwner) {
        setSelectedTeam(teamOwner);
      } else {
        setSelectedTeam(teamOptionValue?.[0]);
      }
    }
  }, [teamOptionValue]);

  const handleSendEmailInvite = () => {
    if (inviteSent) {
      handleModalOpen();
      return;
    }

    setAddSeatLoading(true);
    const tempData = invitedMembers.map(({ email }) => email);
    sendEmailInvite({ emails: tempData }, selectedTeam?.id).then(
      (res) => {
        const { data } = res.data;

        const users = data.map((member) => ({
          role: 'invited',
          _id: member._id,
          email: member.user?.email || member.recipientEmail,
          name: member.user?.name || '-',
          lastLogin: member.user?.lastLogin || '-',
          picture: member.user?.picture || null,
          status: 'pending',
        }));
        const tempArray = [...teamMembers, ...users];
        setTeamMembers(tempArray);
        // }
        setInviteSent(true);
        // handleModalOpen();
        setEmailInviteValue('');
        setAddSeatLoading(false);
        dispatch(
          setInvitedMembers({
            type: 'clear',
          })
        );
      },
      (err) => {
        dispatch(
          setCustomAlert({
            message: 'Something went wrong, Try again!',
            state: true,
            type: 'error',
          })
        );
        setAddSeatLoading(false);
        setEmailInviteValue('');
        handleModalOpen();
      }
    );
  };

  const handleDropDownOption = (type, data, deleteType) => {
    const tempData = [...teamMembers];
    if (type === 'resend') {
      setTeamMembers();
      dispatch(setLoading(true));
      resendEmailInvite(data, selectedTeam.id).then(
        () => {
          dispatch(setLoading(false));
          dispatch(
            setCustomAlert({
              message: 'Invite has been resent successfully!',
              state: true,
              type: 'success',
            })
          );
          setTeamMembers(tempData);
        },
        () => {
          dispatch(setLoading(false));
          setTeamMembers(tempData);
          dispatch(
            setCustomAlert({
              message: 'Something went wrong! TRY AGAIN',
              state: true,
              type: 'error',
            })
          );
        }
      );
    } else if (type === 'delete') {
      setTeamMembers();
      if (deleteType === 'invited') {
        dispatch(setLoading(true));
        deleteInvite(data, selectedTeam.id).then(
          () => {
            const index = tempData.findIndex((o) => o._id === data);
            tempData.splice(index, 1);
            dispatch(setLoading(false));
            setTeamMembers(tempData);
            dispatch(
              setCustomAlert({
                message: 'User has been deleted successfully!',
                state: true,
                type: 'success',
              })
            );
          },
          () => {
            dispatch(setLoading(false));
            setTeamMembers(tempData);
            dispatch(
              setCustomAlert({
                message: 'Something went wrong! TRY AGAIN',
                state: true,
                type: 'error',
              })
            );
          }
        );
      } else {
        dispatch(setLoading(true));
        deleteMembers(data, selectedTeam.id).then(
          () => {
            const filteredTeam = teamMembers.filter((o) => o._id !== data);
            setTeamMembers(filteredTeam);
            dispatch(setLoading(false));
            dispatch(
              setCustomAlert({
                message: 'User has been deleted successfully!',
                state: true,
                type: 'success',
              })
            );
          },
          () => {
            dispatch(setLoading(false));
            setTeamMembers(tempData);
          }
        );
      }
    }
  };

  const handleNavigation = () => {
    router.push('/plans');
  };
  const handleAddSeatToolTip = (state) => {
    if (!state) {
      setShowTooltip({ plansSeats: false, updateSeats: true });
    }
  };
  const handleChange = (event) => {
    setSelectedTeam(event.target.value);
  };
  const { theme } = useTheme();
  return (
    <>
      {dataFetchedFrom === 'API' ? (
        <div>
          {/* <Modal
            bodyStyle={{
              padding: 0,
              // maxWidth: 416,
            }}
            closeIcon={modalType === 'freeuser'}
            // disableBackdropClick={modalLoading}
            maxWidth='xs'
            open={editTeam}
            setOpen={() => setEditTeam(false)}
            titleHeading='Rename Team'
          >
            <div className=' text-md font-bold text-custom-font-color dark:text-white'>
              <div className='font-bold pb-2'>Team Name</div>
              <Grid xs={12}>
                <TextField
                  getValue={(event) => setEditTeamName(event.target.value)}
                  value={editTeamName}
                  placeholder='Eg: JohnDoe@example.com'
                  fullWidth
                />
              </Grid>
              <Grid className='flex justify-end pt-3'>
                <Button
                  loading={localLoadingState}
                  btnColor='blue'
                  onClick={() => {
                    handleEditName(editTeamName, selectedTeam?.id);
                  }}
                >
                  {localLoadingState ? <LoadingState /> : 'Save'}
                </Button>
              </Grid>
            </div>
          </Modal> */}
          <Modal
            bodyStyle={{
              padding: 0,
              // maxWidth: 416,
            }}
            closeIcon={modalType === 'freeuser'}
            // disableBackdropClick={modalLoading}
            maxWidth='xs'
            open={updateSeatModal}
            setOpen={() => setUpdateSeatModal(false)}
            titleHeading='Update Seat(s)'
          >
            <UpdateSeat
              noOfSeats={noOfSeats}
              setHelperState={setHelperState}
              helperState={helperState}
              selectedTeam={selectedTeam}
              handleAddMemberModalOpen={handleModalOpen}
              setUpdateSeatModal={setUpdateSeatModal}
              addOnSeatsCount={addOnSeatsCount}
              user={user}
              availableSeat={availableSeat}
              paymentMethods={paymentMethods}
              setLocalLoadingState={setLocalLoadingState}
              localLoadingState={localLoadingState}
            />
          </Modal>
          <Modal
            bodyStyle={{
              padding: 0,
              // maxWidth: 416,
            }}
            closeIcon={modalType === 'freeuser'}
            // disableBackdropClick={modalLoading}
            maxWidth='xs'
            open={modalOpen}
            setOpen={handleModalOpen}
            titleHeading={
              ['invite', 'outofseats']?.includes(modalType)
                ? 'Add New User'
                : modalType === 'assignRole'
                ? 'Assign Role'
                : 'Create Team'
            }
          >
            {modalType === 'invite' ? (
              <InviteModal
                setHelperState={setHelperState}
                helperState={helperState}
                teamID={selectedTeam?.id}
                teamMembers={teamMembers}
                setModalType={setModalType}
                emailInviteValue={emailInviteValue}
                handleSendEmailInvite={handleSendEmailInvite}
                inviteSent={inviteSent}
                loading={loading}
                setEmailInviteValue={setEmailInviteValue}
                addSeatLoading={addSeatLoading}
              />
            ) : modalType === 'outofseats' ? (
              <OutOfSeats
                handleModalOpen={handleModalOpen}
                setModalType={setModalType}
                handleAddSeatToolTip={handleAddSeatToolTip}
              />
            ) : modalType === 'assignRole' ? (
              <AssignRole
                memberInfo={memberInfo}
                setMemberInfo={setMemberInfo}
                setHelperState={setHelperState}
                helperState={helperState}
              />
            ) : (
              <CreateTeamModal
                classes={classes}
                handleClose={handleModalOpen}
                handleCreateNewTeam={handleCreateNewTeam}
                loading={localLoadingState}
                newTeamValue={newTeamValue}
                setNewTeamValue={setNewTeamValue}
              />
            )}
          </Modal>
          {teamMembers?.length || team?.length ? (
            <Grid
              className={!mobileWidth ? classes.root : 'h-auto'}
              container
              spacing={2}
            >
              <Grid item xs={12} md={5} lg={3.7} className='max-h-full'>
                <Box
                  padding='18px 15px'
                  className='bg-white rounded-md dark:bg-header-black h-full w-full dark:border-1 dark:border-custom-border'
                  border='1px solid #EBEBEF'
                >
                  <div className='pb-2 font-bold'>Team Info</div>

                  {/* <Box
                    className='flex justify-between items-center bg-custom-bgGrey rounded-md dark:bg-header-black  w-full dark:border-1 dark:border-custom-border'
                    border='1px solid #EBEBEF'
                    padding='15px 12px'
                  >
                    <div className='text-sm font-[600]'>
                      {selectedTeam?.label}
                    </div>
                    <CustomToolTip title='Rename Team'>
                      <CreateIcon
                        sx={{
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer',
                        }}
                        onClick={() => setEditTeam(true)}
                        disabled={!selectedTeam?.owner}
                      />
                    </CustomToolTip>
                  </Box> */}

                  {!editTeam ? (
                    <div className='flex'>
                      <CustomAutoComplete
                        options={teamOptionValue}
                        handleChange={handleChange}
                        selectedOption={selectedTeam}
                      />
                      <Button
                        disabled={!selectedTeam?.owner}
                        btnColor='blue'
                        onClick={() => setEditTeam(true)}
                        className={classes.btnIcon}
                      >
                        <CreateIcon />
                      </Button>
                    </div>
                  ) : (
                    <div className='flex'>
                      <Grid xs={11}>
                        <TextField
                          getValue={(event) =>
                            setEditTeamName(event.target.value)
                          }
                          value={editTeamName}
                          placeholder='Eg: JohnDoe@example.com'
                          fullWidth
                        />
                      </Grid>
                      <Grid className='pl-2'>
                        <Button
                          loading={localLoadingState}
                          className={classes.doneBtn}
                          onClick={() => {
                            handleEditName(editTeamName, selectedTeam?.id);
                          }}
                        >
                          {localLoadingState ? <LoadingState /> : <DoneIcon />}
                        </Button>
                      </Grid>
                      <Grid className='pl-2'>
                        <Button
                          onClick={() => setEditTeam(false)}
                          className={classes.closeBtn}
                        >
                          <CloseIcon />
                        </Button>
                      </Grid>
                    </div>
                  )}
                  <Button
                    disabled={!selectedTeam?.owner || !availableSeat}
                    onClick={() => {
                      setModalType('invite');
                      handleModalOpen();
                    }}
                    btnColor='blue'
                    style={{
                      marginTop: '12px',
                      fontSize: '16px',
                    }}
                    fullWidth
                  >
                    <AddIcon className='mr-2' />
                    Add New Member
                  </Button>
                  <Divider
                    sx={{
                      margin: '11px 0px',
                      borderColor: theme === 'dark' ? '#1e2628' : '',
                    }}
                  />
                  {['owner']?.includes(selectedTeam?.role) ||
                  selectedTeam?.owner ? (
                    <Box
                      className='w-full py-5 px-3 rounded-md  dark:border-1 dark:border-custom-border'
                      border='1px solid #EBEBEF'
                      // sx={{ minHeight: '220px' }}
                    >
                      <div className='flex justify-between items-center '>
                        <div className='text-sm font-weight-custom '>
                          My Team Members:
                        </div>
                        <div className='text-xl font-bold text-primary-pink'>
                          {loading ? (
                            <LoadingState size={28} />
                          ) : (
                            teamMembers?.length
                          )}
                        </div>
                      </div>
                      <div className='flex justify-between items-center pt-5'>
                        <div className='text-sm font-weight-custom '>
                          Available Seats:
                        </div>
                        <div className='text-xl font-bold text-secondary-blue'>
                          {/* {loading ? (
                            <LoadingState size={28} />
                          ) : user.userPlan._id ===
                            apiConfig.productIds['seo-rocket'] ? (
                            'UNLIMITED'
                          ) : (
                            availableSeat
                          )} */}
                          {loading ? <LoadingState size={28} /> : availableSeat}
                        </div>
                      </div>

                      {selectedTeam?.role === 'owner' && (
                        <div className='relative flex lg:flex-row items-center flex-row justify-between gap-2 pt-3'>
                          {showTooltip?.plansSeats ? (
                            <ClickAwayListener
                              onClickAway={() =>
                                setShowTooltip((prev) => ({
                                  ...prev,
                                  plansSeats: false,
                                }))
                              }
                            >
                              <div className='absolute bottom-14 z-[10000] left-[-15px] w-[200px] text-xs text-center bg-slate-800 p-2 rounded text-gray-100'>
                                <div className='absolute w-3 h-3 bg-slate-800 bottom-[-2px] translate-x-[55px] rotate-45' />
                                No. of seat(s) available per your plan plus add
                                on seat(s). Click “+” to buy more.
                              </div>
                            </ClickAwayListener>
                          ) : null}
                          {/* {Number(addOnSeatsCount) === ownersPlanData?.users ? (
                          <CustomToolTip
                            title='No. of seat(s) available per your plan plus add on seat(s). Click “+” to buy more.'
                            center
                            placement='top'
                          >
                            <SeatsCounter
                              count={addOnSeatsCount}
                              setCount={setAddOnSeatsCount}
                              availableSeat={availableSeat}
                              min={ownersPlanData?.users}
                              total={teamMembers?.length}
                            />
                          </CustomToolTip>
                        ) : ( */}
                          <SeatsCounter
                            count={addOnSeatsCount}
                            setCount={setAddOnSeatsCount}
                            additionalValues={{
                              min: ownersPlanData?.users,
                              total: teamMembers?.length,
                              availableSeat,
                              noOfSeats,
                            }}
                          />
                          {/* )} */}
                          <div>
                            {showTooltip?.updateSeats ? (
                              <ClickAwayListener
                                onClickAway={() =>
                                  setShowTooltip((prev) => ({
                                    ...prev,
                                    updateSeats: false,
                                  }))
                                }
                              >
                                <div className='absolute bottom-14 z-[10000] right-[-8px] w-[135px] text-xs text-center bg-slate-800	 p-2 rounded text-gray-100'>
                                  <div className='absolute w-3 h-3 bg-slate-800 bottom-[-2px] translate-x-[55px] rotate-45' />
                                  Add seats to invite more members
                                </div>
                              </ClickAwayListener>
                            ) : null}

                            <CustomToolTip title='Add/Remove seats'>
                              <Button
                                style={{
                                  minWidth: '0px',
                                  padding: '10px 8px',
                                }}
                                btnColor='blue'
                                onClick={() => setUpdateSeatModal(true)}
                                disabled={
                                  ((!noOfSeats?.type ||
                                    noOfSeats?.type === 'subtract') &&
                                    noOfSeats?.seats > availableSeat) ||
                                  addOnSeatsCount < ownersPlanData?.users ||
                                  [totalSeats, ''].includes(addOnSeatsCount)
                                }
                              >
                                Update Seats
                              </Button>
                            </CustomToolTip>
                          </div>
                        </div>
                      )}

                      <p className='mt-5 font-bold'>
                        Additional Seat(s):{' '}
                        {noOfSeats?.type ? (
                          <span className='text-secondary-blue'>
                            {noOfSeats?.type === 'add' ? '+' : '-'}

                            {noOfSeats?.seats}
                          </span>
                        ) : (
                          '0'
                        )}
                      </p>

                      {/* NLO Rocket plan */}
                    </Box>
                  ) : (
                    <Box
                      className='w-full py-5 px-3 rounded-md  dark:border-1 dark:border-custom-border'
                      border='1px solid #EBEBEF'
                      // sx={{ minHeight: '220px' }}
                    >
                      <div className='flex justify-between items-center'>
                        <div className='text-sm font-weight-custom '>
                          No. of Users
                        </div>
                        <Typography
                          variant='body1'
                          className='font-weight-custom text-secondary-blue'
                        >
                          {loading ? <LoadingState /> : teamMembers?.length}
                        </Typography>
                      </div>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} md={7} lg={8.3} className='max-h-full'>
                <TeamTable
                  handleDropDownOption={handleDropDownOption}
                  teamMembers={teamMembers}
                  selectedTeam={selectedTeam}
                  loading={loading}
                  setModalType={setModalType}
                  handleModalOpen={handleModalOpen}
                  setSelectedTeam={setSelectedTeam}
                />
              </Grid>
            </Grid>
          ) : !user?.userPlan?.isDefault &&
            !user?.trialInfo?.isTrialActivated &&
            restrictCreatingTeam(user?.userPlan) ? (
            <Grid className={!mobileWidth ? classes.root : 'h-auto'}>
              <Box
                padding='20px 15px'
                className='bg-white dark:bg-header-black h-full w-full flex justify-center items-center dark:border-1 dark:border-custom-border sm:min-h-[74vh]'
                border='1px solid #EBEBEF'
              >
                <div className='text-center px-3'>
                  <div className='flex justify-center w-full'>
                    <img
                      width='96px'
                      alt='diamong'
                      src='/assets/big.diamond.png'
                    />
                  </div>
                  <div className='py-4 text-center'>
                    Since you have upgraded to <b> {user?.userPlan?.name}</b>,
                    <br /> you can now create a team and invite your colleagues
                    to join it.
                  </div>
                  <Button
                    // style={{
                    //   marginTop: '15px',
                    //   backgroundColor: '#2499E7',
                    //   padding: '10px 0px',
                    // }}
                    btnColor='blue'
                    onClick={handleNewTeamModal}
                    disabled={!user?.subscription}
                    // type='basic'
                  >
                    Create Team
                  </Button>
                </div>
              </Box>
            </Grid>
          ) : (
            <Grid className={!mobileWidth ? classes.root : 'h-auto'}>
              <Box
                padding='20px 15px'
                className='bg-white dark:bg-header-black h-full w-full flex justify-center items-center dark:border-1 dark:border-custom-border sm:min-h-[74vh]'
                border='1px solid #EBEBEF'
              >
                <div className='flex flex-col gap-[6px] text-center px-3'>
                  <div className='flex justify-center w-full'>
                    <img
                      width='293.92px'
                      height='239.68px'
                      alt='diamond'
                      src='/assets/upgrade-plan.png'
                    />
                  </div>
                  <div
                    style={{
                      color: theme === 'dark' ? '#fff' : '#505876',
                      fontFamily: 'Montserrat',
                      lineHeight: '24px',
                      fontSize: '20px',
                      marginTop: '20px',
                    }}
                  >
                    <b>Upgrade to Enterprise</b>
                  </div>
                  <div className='py-4 text-center'>
                    <p>
                      {user?.trialInfo?.isTrialActivated
                        ? `Right now, you are on trial and trial plan does not include this feature.`
                        : `Your plan doesn’t include Team Management.`}
                    </p>
                    <p>
                      {user?.trialInfo?.isTrialActivated
                        ? ``
                        : `Create a team and invite team members by upgrading to Enterprise.`}
                    </p>
                  </div>

                  {user?.trialInfo?.isTrialActivated ? null : (
                    <Button
                      id='button-navigate-plans'
                      className='gradient-btn'
                      onClick={handleNavigation}
                    >
                      Upgrade Now
                    </Button>
                  )}
                </div>
              </Box>
            </Grid>
          )}
        </div>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}

ManageTeams.propTypes = {
  team: PropTypes.array,
  user: PropTypes.object,
  handleCreateNewTeam: PropTypes.func,
  handleNewTeamModal: PropTypes.func,
  teamOptionValue: PropTypes.object,
  setTeamOptionValue: PropTypes.func,
  teamMembers: PropTypes.array,
  setTeamMembers: PropTypes.func,
  localLoadingState: PropTypes.bool,
  setLocalLoadingState: PropTypes.func,
  newTeamValue: PropTypes.string,
  setNewTeamValue: PropTypes.func,
  selectedTeam: PropTypes.object,
  memberInfo: PropTypes.object,
  setSelectedTeam: PropTypes.func,
  modalType: PropTypes.string,
  setModalType: PropTypes.func,
  inviteSent: PropTypes.bool,
  setInviteSent: PropTypes.func,
  handleModalOpen: PropTypes.func,
  setMemberInfo: PropTypes.func,
  dataFetchedFrom: PropTypes.string,
};
